import { Badge, borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { InsightDetails } from './insights-details/InsightDetails';

export const InsightCardRoot = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 8px;
  border-bottom: 1px solid var(--border-soft);
  min-height: 72px;
  cursor: pointer;

  &:hover {
    background-color: ${props => !props.$isActive && 'var(--surface-hover)'};
  }

  ${({ $isActive }) => {
    return (
      $isActive &&
      css`
        border-bottom: unset;
        background-color: var(--surface-active);
      `
    );
  }}
`;

export const IconWrapper = styled.div`
  width: 40px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const AnalysisInfo = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: end;
  min-width: fit-content;
  text-align: right;
  color: var(--text-soft);
`;

export const AnalysisType = styled.span`
  ${typographyV2.bodySm};
`;

export const StyledBadge = styled(Badge)`
  ${Badge.Styled.BadgeTextual} {
    padding: 2px 4px;
    ${borderRadius.r05};
  }
`;

export const InsightDetailsWrapper = styled.div`
  ${InsightDetails.Styled.MainInfo} {
    max-width: 100%;
  }
`;
